import type {
  ScheduleWeekActivity,
  ScheduleWeekExercise,
  ScheduleWeekLesson,
} from "api/services/treatment/schemas/ScheduleWeek";

import type { ProtocolCard, ProtocolCardAttrs } from "./types";

export function isActivity(activity: ProtocolCard): activity is ScheduleWeekActivity & ProtocolCardAttrs {
  return (
    activity.activity_type_trimmed === "activity" ||
    activity.activity_type_trimmed === "report" ||
    activity.activity_type_trimmed === "payment"
  );
}

export function isExercise(activity: ProtocolCard): activity is ScheduleWeekExercise & ProtocolCardAttrs {
  return activity.activity_type_trimmed === "exercise";
}

export function isLesson(activity: ProtocolCard): activity is ScheduleWeekLesson & ProtocolCardAttrs {
  return activity.activity_type_trimmed === "lesson";
}
